import MesCalendarioEmpleado from 'components/calendario/MesCalendarioEmpleado'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Col, Input,  Row, Table } from 'reactstrap'
import { apiAusenciasService } from 'services/apiAusenciasService'

const EmpleadoDetalleCalendario = (props) => {
    const { id } = useParams()
    const [year, setYear] = useState(new Date().getFullYear())
    const [computoAnual, setComputoAnual] = useState(null)

    const meses = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"]

  
    useEffect(() => {
        const fetchData = async () => {
            const responseComputo = await apiAusenciasService.getComputo(id, year)
            setComputoAnual(responseComputo)
    
        }
        fetchData()

        return () => {

        }
    }, [props.empleado, year, id])

    return (
        <>
            <div className='mb-3'>
                <Row className='mb-2'>
                    <Col> <h3> Computo de días anual:</h3></Col>
                    <Col lg={2}><Input className="form-control-alternative" type="number" id="year" name="year" min="1900" max="2100" step="1" value={year} onChange={(e) => setYear(e.target.value)} /></Col>
                </Row>

                <Table>
                    <thead>
                        <tr>
                            <th>Laborables</th>
                            <th>Vacaciones</th>
                            <th>Festivos</th>
                            <th>Ausencias</th>
                            <th>Bajas</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className='text-primary ' style={{fontSize:16}}>{computoAnual?.laborables}</td>
                            <td className='text-success' style={{fontSize:16}}>{computoAnual?.vacaciones}</td>
                            <td className='text-danger' style={{fontSize:16}}>{computoAnual?.festivos}</td>
                            <td className='text-info' style={{fontSize:16}}>{computoAnual?.ausecias}</td>
                            <td className='text-warning' style={{fontSize:16}}>{computoAnual?.bajas}</td>
                        </tr>
                    </tbody>
                </Table>

            </div>

            <div className='mb-3'>

                <h3 className='mb-2'> Calendario:</h3>

                <Row>
                    {meses.map((mes, index) => (
                        <Col lg={4} className='mb-1' >
                        <MesCalendarioEmpleado
                            anno={year}
                            mes={index}
                            empleado={props.empleado}
                            nombreMes={mes}
                        ></MesCalendarioEmpleado>
                        </Col>
                    ))}
               
                   
                </Row>

            </div>
        </>
    )
}

export default EmpleadoDetalleCalendario